import React from "react";
import { Box, Modal, Button, Grid, Typography } from "@mui/material";
import ListAlt from "@mui/icons-material/ListAlt";
import { getPatientByIdNum } from "../../../api/api";
import ArticleIcon from "@mui/icons-material/Article";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

function ViewScannedDocsModal({ IDNumber, props }) {
  const [patientDocs, setPatientDocs] = React.useState({
    document1: "",
    document2: "",
    document3: "",
  });

  React.useEffect(() => {
    const getPatients = async () => {
      const [patient, err] = await getPatientByIdNum(IDNumber);
      if (err){
        console.log("error getting patient",err)
      }
      console.log("YEEA", patient);
     //let stringPatient = JSON.stringify( patient)
     //localStorage.setItem("reportPatient",stringPatient)
      if (patient) {
        setPatientDocs({
          document1: patient.data.Documents.ID_DOC,
          document2: patient.data.Documents.MEDICAL_AID_DOC,
          document3: patient.data.Documents.REF_NOTE_DOC,
        });
      } else {
        setPatientDocs({
          document1: "",
          document2: "",
          document3: "",
        });
        props.enqueueSnackbar("COULD NOT GET PATIENT DATA FOR IAMGES", {
          preventDuplicate: true,
          variant: "error",
        });
      }
    };
    getPatients();
  }, []);

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const viewScannedDocuments = () => {
    setOpen(true);
  };
  const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    margin: theme.spacing(1),
    marginLeft: 0,
    marginTop: 0,
    minHeight: 40,
  }));

  const viewDocument = (document) => {
    if (!document) {
      props.enqueueSnackbar(`THE DOCUMENT FOR THIS PATIENT WAS NOT UPLOADED`, {
        preventDuplicate: true,
      });
    } else {
      var w = window.open("about:blank");

      setTimeout(() => {
        w.document.body.appendChild(w.document.createElement("img")).src =
          document;
        w.document.body.style.margin = 0;
        w.document.getElementsByTagName("img")[0].style.width = "100%";
        w.document.getElementsByTagName("img")[0].style.height = "100%";
        w.document.getElementsByTagName("img")[0].style.border = 0;
      }, 0);
    }
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box sx={style.container} container spacing={2}>
          <Item
            variant="outlined"
            sx={style.btn}
            onClick={() => viewDocument(patientDocs.document1)}
          >
            <ArticleIcon sx={style.icon} />
            <Typography sx={style.text}>ID DOCUMENT</Typography>
          </Item>

          <Item
            variant="outlined"
            sx={style.btn}
            onClick={() => viewDocument(patientDocs.document2)}
          >
            <ArticleIcon sx={style.icon}/>
            <Typography sx={style.text}>MEDICAL AID DOCUMENT</Typography>
          </Item>

          <Item
            variant="outlined"
            sx={style.btn}
            onClick={() => viewDocument(patientDocs.document3)}
          >
            <ArticleIcon sx={style.icon}/>
            <Typography sx={style.text}>REF NOTE DOCUMENT</Typography>
          </Item>
        </Box>
      </Modal>
      <Button
        variant="outlined"
        fullWidth
        color="secondary"
        size="large"
        startIcon={<ListAlt />}
        onClick={viewScannedDocuments}
        sx={{ fontSize: "14px" }}
      >
        View Scanned Documents
      </Button>
    </>
  );
}
const style = {
  container: {
    dispaly: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    width: "30%",
    alignItems: "center",
    padding : ' 0px 20px'
  },
  btn: {

    cursor: "pointer",
    textAlign: "center",
    display: "flex",
    
    alignItems: "center",
    margin :'20px 0px',
    position:'relative'
  },
  icon : {
    //marginRight : '20px',
    //marginLeft:'20%'
    position : 'absolute',
    left : '30%'
  },
  text : {
    marginLeft : '40%'
  }
};
export default ViewScannedDocsModal;
